// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__uZLXC","background":"banner_background__ZYkON","copy":"banner_copy__3loz6"};